module.exports = __webpack_public_path__ + "img/p2_12.8d19ec97.png";